<template>
    <div class="text-md-left">
        <el-form :model="data.shopDetail" :rules="rules" ref="shopServiceInfo" label-width="220px" label-position="left">
            <el-form-item label="Dim Weight Multiplier" prop="dimWeightMultiplier">
                <!-- <el-input v-model="data.shopDetail.dimWeightMultiplier"></el-input> -->
                <!-- <el-input v-model="data.shopDetail.dimWeightMultiplier"></el-input> -->
                <vue-numeric
                      :precision="2"
                      separator=","
                      v-model="data.shopDetail.dimWeightMultiplier"
                      class="el-input__inner"
                    ></vue-numeric>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
// import fgApi from '@/services/fillgoods'
import VueNumeric from 'vue-numeric'
export default {
    name: 'shopInfoForm',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    components: {
        VueNumeric
    },
    data () {
        return {
            rules: {
                // dimWeightMultiplier: [{ required: true, message: 'กรุณากรอก Dim Weight Multiplier', trigger: 'blur' }]
            }
        }
    },
    watch: {},
    created () {},
    methods: {

    }
}
</script>
